import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
// import { Form } from "./Form";
// import { TableAll } from "./TableAll";
import { ProgressSpinner } from "primereact/progressspinner";
// import { Table } from "./Table";
import { IRequirementMast } from "../../models/RequirementMast";
import { EmptyRequirement } from "../requirement/EmptyRequirement";
import { Table } from "./Table";
import { Form } from "./Form";


export interface IModel {
    open: boolean,
    singleData: IRequirementMast
}

export const PocTransferReq = (permissions: { tab: number, is_Create?: boolean, is_Delete?: boolean, is_Update?: boolean, is_Export?: boolean, is_View?: boolean }) => {
    const [modal, setModal] = useState({ singleData: EmptyRequirement, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);
    const [spinner, setSpinner] = useState(false);


    const hideDialog = () => {
        setModal({ singleData: EmptyRequirement, open: false });
    };

    return (
        <>
            {spinner && <ProgressSpinner className="m-auto left-50 mt-8" />}
            {/* {((permissions.is_Create || permissions.is_Update) && permissions.tab === 2) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} ></Form>} */}
            {permissions.is_Create && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} ></Form>}
            {/* {permissions.tab === 1 && <TableAll permissions={permissions} toast={toast} reload={reload} setReload={setReload} />} */}
            {/* {permissions.tab === 1 && !spinner && <Table  setSpinner={setSpinner} permissions={permissions} setModal={setModal} toast={toast} reload={reload} spinner={spinner} setReload={setReload} />} */}
            {permissions.is_View && <Table  setSpinner={setSpinner} permissions={permissions} setModal={setModal} toast={toast} reload={reload} spinner={spinner} setReload={setReload} />}
            <Toast ref={toast} />
        </>
    );
}
